import React from 'react';

import { Skeleton } from '@material-ui/lab';
import styled from 'styled-components';
import { Divider1, StyledGrid } from 'styles/common';

const FormSkeletonLoader = ({ rows = 5 }) => (
  <AlertContainer>
    <Skeleton width="100%" height="4rem" />
    <Divider1 />
    {Array.from({ length: rows }).map((i) => (
      <StyledGrid container>
        <StyledGrid item xs={12}>
          <Skeleton width="100%" height="2rem" />
        </StyledGrid>
      </StyledGrid>
    ))}
  </AlertContainer>
);

export default FormSkeletonLoader;

const AlertContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 2rem;
`;
